import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivateRoute from "./utils/PrivateRoutes";
import Navigation from "./components/Navigation";
import Home from "./pages/Home";
import Docs from "./pages/Docs";
import Feedback from "./pages/Feedback";
import Help from "./pages/Help";
import Register from "./pages/Register";
import Signin from "./pages/Signin";
import Workarea from "./pages/Workarea";
// import PrivateRoute from "./utils/PrivateRoutes";
import ReviewData from "./pages/ReviewData";
import { AuthProvider } from "./context/AuthContext";
import {DataDescriptionProvider} from "./context/DataDescriptionContext";
import { PlotDataProvider } from "./context/PlotData";
import DataDescription from './pages/DataDscription';
import DataPreprocessing from "./pages/DataPreprocessing";
import DataVizualization from "./pages/DataVizualization";
import FeatureEngineering from "./pages/FeatureEngineering";
import ModelEvalution from "./pages/ModelEvalution";
import Regression from "./pages/ModelSelection";
import Classification from "./pages/Classification";
import TSA from "./pages/TimeSeriasAnalysis";
import Clustering from "./pages/Clustering";
import Report from "./pages/Report";
//DOCs
import DataDescriptionDoc from "./components/DataDescriptionDoc";
import DataPreprocessingDoc from "./components/DataPreprocessingDoc";
import DataVisualizationDoc from "./components/DataVisualizationdoc";
import FeatureEngineeringDoc from "./components/FeatureEngineeringDoc";
import FeatureExtractionDoc from "./components/FeatureExtractionDoc";
import FeatureScalingDoc from "./components/FeatureScalingDoc";
import FeatureSelectionDoc from "./components/FeatureSelection";
import FeatureTransformationDoc from "./components/FeatureTransformationDoc";
import ModelBuildingDoc from "./components/ModelBuildingDoc";
import ModelMonitoringDoc from "./components/ModelMonitoringDoc";
import ModelEvalutionDoc from "./components/ModelEvalutionDoc";


function App() {

  return (
    <div className="">
      <Router>
        <AuthProvider>
          <Navigation />
          <Routes>
            <Route element={<Home />} path="/" exact />
            <Route exact path="/docs" element={<Docs />} />
            <Route exact path="/feedback" element={<Feedback />} />
            <Route exact path="/help" element={<Help />} />
            <Route exact path="/register" element={<Register />} />
            <Route exact path="/signin" element={<Signin />} />
            {/* <Route exact path="/signin" element={<Signin />} /> */}
            <Route exact path="/datadescriptiondoc" element={<PrivateRoute><DataDescriptionDoc /></PrivateRoute>} />
            <Route exact path="/datapreprocessingdoc" element={<PrivateRoute><DataPreprocessingDoc /></PrivateRoute>} />
            <Route exact path="/datavisualizationdoc" element={<PrivateRoute><DataVisualizationDoc /></PrivateRoute>} />
            <Route exact path="/featureextractiondoc" element={<PrivateRoute><FeatureExtractionDoc /></PrivateRoute>} />
            <Route exact path="/featureengineeringdoc" element={<PrivateRoute><FeatureEngineeringDoc /></PrivateRoute>} />
            <Route exact path="/featuretransformationdoc" element={<PrivateRoute><FeatureTransformationDoc /></PrivateRoute>} />
            <Route exact path="/featurescalingdoc" element={<PrivateRoute><FeatureScalingDoc /></PrivateRoute>} />
            <Route exact path="/featureselectiondoc" element={<PrivateRoute><FeatureSelectionDoc /></PrivateRoute>} />
            <Route exact path="/modelbuildingdoc" element={<PrivateRoute><ModelBuildingDoc /></PrivateRoute>} />
            <Route exact path="/modelevalutiondoc" element={<PrivateRoute><ModelEvalutionDoc /></PrivateRoute>} />
            <Route exact path="/modelmonitoringdoc" element={<PrivateRoute><ModelMonitoringDoc /></PrivateRoute>} />
          </Routes>
          <DataDescriptionProvider>
            <Routes>
              <Route exact path="/workarea" element={<PrivateRoute><Workarea /></PrivateRoute>} />
              <Route exact path="/reviewdata" element={<PrivateRoute><ReviewData /></PrivateRoute>}/>
              <Route exact path="/data-description" element={<PrivateRoute><DataDescription /></PrivateRoute>}/>
              <Route exact path="/data-preprocessing" element={<PrivateRoute><DataPreprocessing /></PrivateRoute>}/>
              <Route exact path="/feature-enginerring" element={<PrivateRoute><FeatureEngineering /></PrivateRoute>}/>
              <Route exact path="/regression" element={<PrivateRoute><Regression /></PrivateRoute>}/>
              <Route exact path="/classification" element={<PrivateRoute><Classification /></PrivateRoute>}/>
              <Route exact path="/tsa" element={<PrivateRoute><TSA /></PrivateRoute>}/>
              <Route exact path="/clustering" element={<PrivateRoute><Clustering /></PrivateRoute>}/>
              <Route exact path="/model-evaluation" element={<PrivateRoute><ModelEvalution /></PrivateRoute>}/>
              <Route exact path="/report" element={<PrivateRoute><Report/></PrivateRoute>} />
            </Routes>
          </DataDescriptionProvider>
          <PlotDataProvider>
            <Routes>
            <Route exact path="/data-vizualization" element={<PrivateRoute><DataVizualization /></PrivateRoute>}/>
            </Routes>
          </PlotDataProvider>
        </AuthProvider>
      </Router>
    </div>
   
  );
}

export default App;
